/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_TitleInputs */

const vi_station_title = /** @type {(inputs: Station_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khu vực đóng hàng`)
};

/**

* @param {Station_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_title = /** @type {((inputs?: Station_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_title(inputs)
});